import { auth } from 'db/config';

export const createPayment = async (paymentData) => {
  const {
    paymentMethodId: payment_method_id,
    issuerId: issuer_id,
    cardholderEmail: email,
    amount,
    token,
    identificationNumber,
    identificationType,
  } = paymentData;

  let headers = {
    'Content-Type': 'application/json',
  };
  if (auth.currentUser) {
    const idToken = await auth.currentUser.getIdToken();
    headers['Authorization'] = `Bearer ${idToken}`;
  }

  const response = await fetch(process.env.MONUS_API_URL + '/process-payment', {
    method: 'POST',
    headers: headers,
    body: JSON.stringify({
      description: 'Plan de suscripción',
      email,
      identificationType,
      installments: 1,
      issuer: issuer_id,
      number: identificationNumber,
      paymentMethodId: payment_method_id,
      token,
      transaction_amount: Number(amount),
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Error al procesar el pago');
  }

  const data = await response.json();

  return {
    data,
    message: 'Pago procesado con éxito',
    success: true,
    token,
  };
};
